import { get } from 'lodash';
import { useFindRecord } from 'api/APIHooks';

const useAuthorizationWithLineage = (serviceAuthorization, enabled = true) => {
  const queryResult = useFindRecord(
    'service_authorization',
    serviceAuthorization.id,
    {
      customParams: {
        include: 'lineage',
      },
      queryConfig: {
        enabled: !!serviceAuthorization.id && enabled,
        placeholderData: undefined,
      },
    },
  );

  const { data: authWithLineageData, isSuccess } = queryResult;
  const authWithLineage = get(authWithLineageData, 'data.data', serviceAuthorization);
  const lineageData = get(authWithLineage, 'lineage', []);
  const feeScheduleProgram = get(authWithLineage, 'fee_schedule_program');

  const lineageAuthorizations = lineageData.map((auth) => ({
    ...auth,
    ...(feeScheduleProgram && { fee_schedule_program: feeScheduleProgram }),
  }));

  return {
    currentAuthorization: authWithLineage,
    lineageAuthorizations,
    isSuccess,
    queryData: authWithLineageData,
  };
};

export default useAuthorizationWithLineage;
